import React from 'react';
import {
  rssFeedUrl,
  spotifyUrl,
  applePodcastsUrl,
  googlePodcastsUrl,
  youtubeUrl,
  amazonMusicUrl,
  pocketCastsUrl,
  overcastUrl,
  iHeartRadioUrl,
  stitcherUrl,
  tuneinUrl,
  playerFmUrl
} from '../utils/podcastInfo';

const SubscribeSection = () => {
  return (
    <section className="subscribe">
      <div className="container">
        <h2>Listen & Subscribe</h2>
        <p>Subscribe to Containerized Conversations on your favorite platform to never miss an episode.</p>
        <div className="platform-links">
          {spotifyUrl && (
            <a href={spotifyUrl} className="platform-link" target="_blank" rel="noopener noreferrer">
              <img src="https://cdn-icons-png.flaticon.com/512/2111/2111624.png" alt="Spotify" />
              <span>Spotify</span>
            </a>
          )}
          {applePodcastsUrl && (
            <a href={applePodcastsUrl} className="platform-link" target="_blank" rel="noopener noreferrer">
              <img src="https://cdn-icons-png.flaticon.com/512/831/831276.png" alt="Apple Podcasts" />
              <span>Apple Podcasts</span>
            </a>
          )}
          {googlePodcastsUrl && (
            <a href={googlePodcastsUrl} className="platform-link" target="_blank" rel="noopener noreferrer">
              <img src="https://cdn-icons-png.flaticon.com/512/2875/2875413.png" alt="Google Podcasts" />
              <span>Google Podcasts</span>
            </a>
          )}
          {youtubeUrl && (
            <a href={youtubeUrl} className="platform-link" target="_blank" rel="noopener noreferrer">
              <img src="https://cdn-icons-png.flaticon.com/512/1384/1384060.png" alt="YouTube" />
              <span>YouTube</span>
            </a>
          )}
          {amazonMusicUrl && (
            <a href={amazonMusicUrl} className="platform-link" target="_blank" rel="noopener noreferrer">
              <img src="https://cdn-icons-png.flaticon.com/512/5968/5968282.png" alt="Amazon Music" />
              <span>Amazon Music</span>
            </a>
          )}
          {iHeartRadioUrl && (
            <a href={iHeartRadioUrl} className="platform-link" target="_blank" rel="noopener noreferrer">
              <img src="https://cdn-icons-png.flaticon.com/512/5968/5968747.png" alt="iHeartRadio" />
              <span>iHeartRadio</span>
            </a>
          )}
          {stitcherUrl && (
            <a href={stitcherUrl} className="platform-link" target="_blank" rel="noopener noreferrer">
              <img src="https://cdn-icons-png.flaticon.com/512/2504/2504938.png" alt="Stitcher" />
              <span>Stitcher</span>
            </a>
          )}
          {pocketCastsUrl && (
            <a href={pocketCastsUrl} className="platform-link" target="_blank" rel="noopener noreferrer">
              <img src="https://cdn-icons-png.flaticon.com/512/732/732208.png" alt="Pocket Casts" />
              <span>Pocket Casts</span>
            </a>
          )}
          {overcastUrl && (
            <a href={overcastUrl} className="platform-link" target="_blank" rel="noopener noreferrer">
              <img src="https://cdn-icons-png.flaticon.com/512/732/732228.png" alt="Overcast" />
              <span>Overcast</span>
            </a>
          )}
          {tuneinUrl && (
            <a href={tuneinUrl} className="platform-link" target="_blank" rel="noopener noreferrer">
              <img src="https://cdn-icons-png.flaticon.com/512/5968/5968961.png" alt="TuneIn" />
              <span>TuneIn</span>
            </a>
          )}
          {playerFmUrl && (
            <a href={playerFmUrl} className="platform-link" target="_blank" rel="noopener noreferrer">
              <img src="https://cdn-icons-png.flaticon.com/512/5968/5968770.png" alt="Player.fm" />
              <span>Player.fm</span>
            </a>
          )}
          {rssFeedUrl && (
            <a href={rssFeedUrl} className="platform-link" target="_blank" rel="noopener noreferrer">
              <img src="https://cdn-icons-png.flaticon.com/512/5968/5968841.png" alt="RSS Feed" />
              <span>RSS Feed</span>
            </a>
          )}
        </div>
      </div>
    </section>
  );
};

export default SubscribeSection;